import React from "react";
import HeaderTasks from "../components/HeaderTasks";
import Footer from "../components/Footer";
import '../styles/settings.css'
function Settings(){
    return <div className="settings-section">
    <HeaderTasks/>
    <Footer/>
    </div>
}
export default Settings